import LeadWelcomeEmailTemplate from './LeadWelcomeEmailTemplate';

export default LeadWelcomeEmailTemplate;
